interface KpiCardProps {
  label: string;
  value: string;
  color?: "default" | "green" | "red" | "amber";
  subtitle?: string;
  testId?: string;
}

const colorMap = {
  default: "text-fg",
  green: "text-safe-green",
  red: "text-block-red",
  amber: "text-caution-amber",
} as const;

export function KpiCard({ label, value, color = "default", subtitle, testId }: KpiCardProps) {
  const isSavings = color === "green";
  const surfaceCls = isSavings ? "kpi-savings" : "bg-surface";

  return (
    <div
      data-testid={testId}
      className={`group relative overflow-hidden rounded-lg border border-line-subtle px-4 py-3 transition-all duration-200 hover:border-line hover:-translate-y-px hover:shadow-[0_2px_24px_-12px_color-mix(in_srgb,var(--color-electric-blue)_30%,transparent)] ${surfaceCls}`}
    >
      <p className="text-[10px] font-medium text-fg-faint uppercase tracking-[0.12em]">
        {label}
      </p>
      <p
        className={`kpi-value mt-1 text-xl font-semibold font-mono ${colorMap[color]}`}
      >
        {value}
      </p>
      {subtitle && (
        <p className="mt-0.5 text-xs text-fg-muted">{subtitle}</p>
      )}
      {/* Subtle top accent bar — drawn on hover */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-electric-blue/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"
      />
    </div>
  );
}
